const WEBSITE_KEY = 'beacon_landing_website';
const INSTAGRAM_KEY = 'beacon_landing_instagram';

export const stashLandingValues = ({
	website,
	handle,
}: {
	website: string;
	handle: string;
}) => {
	try {
		const w = website.trim();
		const h = handle.trim();
		if (w) localStorage.setItem(WEBSITE_KEY, w);
		if (h) localStorage.setItem(INSTAGRAM_KEY, h);
	} catch {
		/* storage unavailable */
	}
};

export const consumeLandingWebsite = (fallback: string): string =>
	consume(WEBSITE_KEY, fallback);

export const consumeLandingInstagram = (fallback: string): string =>
	consume(INSTAGRAM_KEY, fallback);

const consume = (key: string, fallback: string): string => {
	try {
		const stored = localStorage.getItem(key);
		if (stored) {
			localStorage.removeItem(key);
			return stored;
		}
	} catch {
		/* storage unavailable */
	}
	return fallback;
};
